import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import CountUp from "react-countup";
import { Message, MessageBox } from "element-react";
import PageTitle from "../../../commons/components/PageTitle";
import {
  InfoArea,
  InfoHead,
  InfoContent,
  InfoList,
  ListWrapper,
  InfoListBox,
} from "../PlantListStyle";
import PS from "../MonitoringApiService";
import ToggleSwitch from "../../../commons/components/input/ToggleSwitch";
import TempSlider from "../../../commons/components/input/Slider";
import { CarrierDataRes } from "./dto/CarrierDataRes";
import MakeKey from "../../../commons/services/MakeKey";
import _ from "lodash";
import StatusButton from "../../../commons/components/button/StatusButton";
import DetailCarrierCard from "./ui/DetailCarrierCard";
import PowerGraph from "./components/PowerGraph";
import { withTranslation } from "react-i18next";
import { DetailCarrierInfoGrid } from "./translationUiConts";
import DetailMeterSection from "./ui/DetailMeterSection";


class PowerCarrierDetail extends Component {
  targetElement = null;
  prevTargetElement = null;

  constructor(props) {
    super(props);
    const { location, match } = this.props;
    const { projectId, device, deviceList } = location.state || {};
    const { id: deviceId } = match.params;
    // 전력량계 시리얼 번호: 설비 기본정보(device.siteNo) 기준 고정 3대 (n00407-{siteNo}-017101~03)
    const fixedMeterSerialNos = [1, 2, 3].map((deviceNo) =>
      MakeKey.meter({ siteNo: device.siteNo, rtuNo: 1, deviceNo })
    );
    this.state = {
      currentTargetElement: null,
      openDeviceId: {
        boiler: device.typeId === 1 ? device.id : null,
        storageTank: device.typeId === 4 ? device.id : null,
      }, // 현재 선택된 기기 ID (boiler, storageTank 둘중하나 해당시 오픈) 
      project: { // 프로젝트 정보
        projectId: projectId,
        projectName: "",
        projectAddr: "",
      },
      deviceId: deviceId,
      device: device,
      deviceList: deviceList,

      meterSerialNos: fixedMeterSerialNos, // 전력량계 시리얼 번호 리스트
      meterData: [], // 전력량계 데이터

      cumulativePower: 0, // 누적 소비전력
      power1hAver: 0, // 1시간 평균 소비전력 // 2025.04.03 미사용
      consPowerTodayMap: {}, // boiler deviceId별 금일 소비전력 (DetailCarrierCard에서 실시간 조회한 값)
      allPowerSwitchStatus: false, // 전체 전원 관리 스위치 상태 값
      allDeviceStatus: 1, // 전체 기기 상태 값

      carrierSerialNos: [], // 캐리어 시리얼 번호 리스트
      carrierData: [], // 1: 캐리어 데이터
      deviceCarrierMappingData: [], // 2: device-carrier 매핑 데이터 { device, carrier }
      matchedBoilerStorageTank: [], // 3: 보일러-축열조 매칭 데이터
      noMatchedBoiler: [], // 4: 다른 전력기기와 연결되지 않은 보일러 데이터
    };

    this.handleTargetTemp = this.handleTargetTemp.bind(this);
    this.handleAllPowerSwitch = this.handleAllPowerSwitch.bind(this);
    this.handleAllDeviceStatus = this.handleAllDeviceStatus.bind(this);
    this.setTargetRef = this.setTargetRef.bind(this);
    this.isTempContr = this.isTempContr.bind(this);
    this.handlePowerSwitch = this.handlePowerSwitch.bind(this);
  }

  componentDidMount() {
    this.fetchGetProjectData();
    this.fetchDeviceList();
    this.fetchCarrierData();

    this.interval = setInterval(() => {
      this.fetchCarrierData();
    }, 1000 * 90); 
  }
  
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps, prevState) {
    const { carrierData } = this.state;
    
    const currentTargetElem = this.targetElement;
    if (currentTargetElem && this.prevTargetElement !== currentTargetElem) {
      this.prevTargetElement = currentTargetElem;
      this.prevTargetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    // carrierData가 변경되면 데이터 세팅
    // 최초로 데이터를 받아온 경우
    // carrierData가 업데이트 되는 경우: 온도조절, 전원관리
    // 온도조절과, 전원관리 함수에서 carrierData를 업데이트한다
    if (prevState.carrierData !== carrierData) {
      this.setData();
    }
  }

  setTargetRef = (el) => {
    this.targetElement = el;
  };

  // DetailCarrierCard에서 boiler별 금일 소비전력을 조회하면 상단 합계에 반영
  handleConsPowerTodayUpdate = (boilerId, consPowerToday) => {
    this.setState((prev) => ({
      consPowerTodayMap: {
        ...prev.consPowerTodayMap,
        [boilerId]: consPowerToday,
      },
    }));
  };

  // device 정보 조회
  async fetchDeviceList() {
    let data = {
      projectId: this.state.project.projectId,
    };

    try {
      await axios.post("/cst/api/device/search", data).then((res) => {
        const resData = res.data.data;
        
        this.setState({ deviceList: resData });
      });
    } catch (error) {
      console.error("전력기기 정보 불러오기 실패", error);
    }
  }

  // 프로젝트 정보 조회
  async fetchGetProjectData() {
    const result = await axios.get(
      `/cst/api/project/id/${this.state.project.projectId}`
    );
    const project = {
      projectName: result.data.name,
      projectAddr: result.data.address,
    }
    this.setState({
      project,
    });
  }

   

  // new carrier mongoDB 데이터
  async fetchCarrierData() {
    const { deviceList } = this.state;

    try {
      // new unique carrier key
      const uniqueCarrierList = []; // { key: `${siteNo}-${rtuNo}`, siteNo, rtuNo, deviceNos: [] }
      const uniqueCarrierKeyList = [];
      // deviceList에서 siteNo, rtuNo가 중복되지 않는 데이터만 추출 (deviceNos: 해당 siteNo, rtuNo에 해당하는 deviceNo들)
      console.log("deviceList: ", deviceList);
      const uniqueMeterList = [];
      const uniqueMeterKeyList = [];

      deviceList.forEach((device) => {
        const { siteNo, deviceNo, rtuNo, typeId, name } = device;
        const key = `${siteNo}-${rtuNo}`;
        if (typeId === 1 || typeId === 4) {
          const findIdx = uniqueCarrierList.findIndex((carrier) => carrier.key === key);
          const carrierKey = MakeKey.carrier({ siteNo, rtuNo, deviceNo });
          uniqueCarrierKeyList.push(carrierKey);
          if (findIdx === -1) {
            uniqueCarrierList.push({
              key,
              siteNo,
              rtuId: rtuNo,
              deviceNos: [deviceNo],
            });
          } else {
            uniqueCarrierList[findIdx].deviceNos.push(deviceNo);
          }
        } else {
          // 전력량계
          const findIdx = uniqueMeterList.findIndex((meter) => meter.key === key);
          const meterKey = MakeKey.meter({ siteNo, rtuNo, deviceNo });
          uniqueMeterKeyList.push(meterKey);
          if (findIdx === -1) {
            uniqueMeterList.push({
              key,
              siteNo,
              rtuId: rtuNo,
              deviceNos: [deviceNo],
              data: device,
            });
          } else {
            uniqueMeterList[findIdx].deviceNos.push(deviceNo);
          }
        }
      });
  
      // carrier data 불러오기
      const carrierData = [];
      const res = await PS.getCarriersData(_.uniq(uniqueCarrierKeyList)) || [];
      res.forEach((data) => {
        const resEntity = new CarrierDataRes(data);
        carrierData.push(resEntity.toObject());
      });

      console.log("uniqueMeterKeyList: ", uniqueMeterKeyList, "uniqueMeterList: ", uniqueMeterList);

      this.setState((prev) => ({
        ...prev,
        carrierSerialNos: uniqueCarrierKeyList,
        carrierData,
        meterData: uniqueMeterList,
        // meterSerialNos는 설비 기본정보(device.siteNo) 기준 고정값을 그대로 유지 (constructor 참고)
      }));

    } catch (error) {
      console.error("캐리어 데이터 불러오기 실패", error);
    }
  }

  // 캐리어 온도 제어
  async fetchContrCarrierTemp(carrierData, kind, controlKind, value) {
    const { t } = this.props;
    const { rtuId, siteNo, deviceNo } = carrierData;
    const val = Number(value);

    try {
      const result = await PS.sendMessageToDevice(rtuId, siteNo, deviceNo, kind, controlKind, val);

    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: t('key607'), // 보일러 목표 온도 설정에 실패했습니다.
      });
    }
  }

  // 데이터 세팅: carrier data가 업데이트 되면 실행 (ex. 최초로 데이터를 받아온 경우 and carrierData가 업데이트 되는 경우)
  // componentdidupdate에서 carrier data 변경 감지하여 실행
  setData() {
    const { deviceList, carrierData } = this.state;
    
    const allTotalConsPower = this.calcAllTotalConsPower(carrierData); // 누적 소비전력 계산
    const allPower1hAver = this.calcAllPower1hAver(carrierData); // 1시간 평균 소비전력 계산
    const allPowerSwitchStatus = carrierData.length > 0 ? carrierData.every((data) => data?.powerState === 1) : false; // ucOpMode가 모두 1인지 확인 (전체 전원 관리 스위치 상태)
    const deviceCarrierMappingData = this.mappingDeviceCarrier(deviceList, carrierData); // device-carrier 매핑 데이터 생성
    const matchedBoilerStorageTank = this.matchBoilderAndStorageTank(deviceCarrierMappingData); // 보일러-축열조 매칭 데이터 생성
    const noMatchedBoiler = deviceCarrierMappingData.filter((data) => data.device.typeId === 1 && !data.device.parentId); // 다른 전력기기와 연결되지 않은 보일러 데이터
    
    this.setState({
      cumulativePower: allTotalConsPower,
      power1hAver: allPower1hAver,
      carrierData,
      allPowerSwitchStatus,
      deviceCarrierMappingData,
      noMatchedBoiler,
      matchedBoilerStorageTank: matchedBoilerStorageTank.sort((a, b) => {
        
        const dateA = new Date(a.boiler.device.createDt);
        const dateB = new Date(b.boiler.device.createDt);
        return dateA - dateB; // 오름차순
      }),
    });
  }

  // 온도 클라이언트 상태값 업데이트
  updateTempSet = (carrierId, value, tempKey) => {
    const { carrierData } = this.state;

    const updatedCarrierData = carrierData.map((carrier) => {
      if (carrier._id === carrierId) {
        return {
          ...carrier,
          [tempKey]: value,
        };
      }
      return carrier;
    });

    this.setState({
      carrierData: updatedCarrierData,
    });
  }

  updateCarrierValue = (carrierId, key, value) => {
    const { carrierData } = this.state;

    const updatedCarrierData = carrierData.map((carrier) => {
      if (carrier._id === carrierId) {
        return {
          ...carrier,
          [key]: value,
        };
      }
      return carrier;
    });

    this.setState({
      carrierData: updatedCarrierData,
    });
  }

  // 개별 전원 관리 
  async handlePowerSwitch_old(carrierId) {
    // console.log("handlePowerSwitch carrierId: ", carrierId);
    // UC 운전모드인지 확인 필요 > 정지, 난방, 냉방이 있음
    const { t } = this.props;
    const { carrierData } = this.state;
    const findCarrier = carrierData.find((carrier) => carrier._id === carrierId);
    const { rtuId, siteNo, deviceNo, ucOpMode, powerState } = findCarrier;
    const controlKind = 3; // 전원 제어
    const kind = 60; 

    try {
      // const messageText = ucOpMode === POWER_STATE.on ? "끄시겠습니까?" : "켜시겠습니까?";
      const messageText = powerState === 1 ? t('key608') : t('key609');
      MessageBox.confirm("해당기기 전원을 " + messageText, "Confirm", {
        confirmButtonText: t('key610'), // 예
        cancelButtonText: t('key611'), // 아니오
        type: "info",
      }).then(async () => {
        const result = await PS.sendMessageToDevice(rtuId, siteNo, deviceNo, kind, controlKind, powerState === 1 ? 0 : 1);
        
        // if (result && result.resultMsg === 'success') {
          this.updateCarrierValue(carrierId, "powerState", powerState === 1 ? 0 : 1);
          Message({
            iconClass: "success",
            type: "success",
            message: t('key612'), // 성공적으로 수행되었습니다.
          })
        // } else {
        //   Message({
        //     iconClass: "cancel",
        //     type: "warning",
        //     message: "개별 전원 관리에 실패했습니다.",
        //   });
        // }
      }).catch(() => {
        // cancel
        Message({
          iconClass: "cancel",
          type: "info",
          message: t('key613'), // 작업이 취소되었습니다.
        })
      })
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: t('key614'), // 개별 전원 관리에 실패했습니다.
      });
    }
  }

// carrier 제어 명령 전송
  async handlePowerSwitch(carrierId) {

     // console.log("handlePowerSwitch carrierId: ", carrierId);
    // UC 운전모드인지 확인 필요 > 정지, 난방, 냉방이 있음
    const { t } = this.props;
    const { carrierData, deviceList } = this.state;
    const carrier = carrierData.find((data) => data._id === carrierId); // 클릭된 보일러의 캐리어 데이터 조회

    if (!carrier) return;
    const { rtuId, siteNo, deviceNo, powerState } = carrier;
    // 제어 API(deviceId)용 device 조회: 캐리어와 동일한 보일러 device
    const device = deviceList.find((dev) => dev.typeId === 1 && String(dev.deviceNo) === String(deviceNo));
    const controlKind = 3; // 전원 제어
    const kind = 60;

    try {
      // const messageText = ucOpMode === POWER_STATE.on ? "끄시겠습니까?" : "켜시겠습니까?";
      const messageText = powerState === 1 ? t('key608') : t('key609');
      MessageBox.confirm("해당기기 전원을 " + messageText, "Confirm", {
        confirmButtonText: t('key610'), // 예
        cancelButtonText: t('key611'), // 아니오
        type: "info",
      }).then(async () => {


  
      const values = [];
      values.push(powerState === 1 ? "off" : "on");  
      

      const item = {
        kind: kind,
        deviceId: device?.id,
        controllItems: ["01"],
        controllValues: values
      };
  
      console.log("item: ", item);

       axios
            .post("/api/device/controll", item)
            .then((response) => {
             console.log("캐리어 제어 명령 전송 성공", response);
            })
            .catch((error) => {
             console.error("캐리어 제어 명령 전송 실패", error);
              alert("보일러 전원 제어를 실패했습니다. 다시 시도해주세요.");
            });
        

        //const result = await PS.sendMessageToDevice(rtuId, siteNo, deviceNo, kind, controlKind, powerState === 1 ? 0 : 1);
        
        // if (result && result.resultMsg === 'success') {
          this.updateCarrierValue(carrierId, "powerState", powerState === 1 ? 0 : 1);
          Message({
            iconClass: "success",
            type: "success",
            message: t('key612'), // 성공적으로 수행되었습니다.
          })
        // } else {
        //   Message({
        //     iconClass: "cancel",
        //     type: "warning",
        //     message: "개별 전원 관리에 실패했습니다.",
        //   });
        // }
      }).catch(() => {
        // cancel
        Message({
          iconClass: "cancel",
          type: "info",
          message: t('key613'), // 작업이 취소되었습니다.
        })
      })
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: t('key614'), // 개별 전원 관리에 실패했습니다.
      });
    }



      
    }


  // 전체 전원 관리
  async handleAllPowerSwitch() {
    const { t } = this.props;
    const { carrierData, deviceList } = this.state;
    const param = {
      rtuId: "",
      siteNo: "",
      deviceId: -1,
      kind: "23",
      controlKind: "3",
      val: ""
    }
     const kind = 60; 
     
    console.log(deviceList);

    const firstCarrier = deviceList.find((device) => device.typeId === 1);
    if (!firstCarrier) return;

    try {
      const messageText = t('key615') + (this.state.allPowerSwitchStatus ? t('key608') : t('key609'));
      MessageBox.confirm(messageText, "Confirm", {
        confirmButtonText: t('key610'), // 예
        cancelButtonText: t('key611'), // 아니오
        type: "info",
      }).then(async () => {
      //  const result = await PS.sendMessageToModule(param);

      const values = [];
      values.push(this.state.allPowerSwitchStatus ? "off" : "on"); // 현재 전체 on 상태면 끄기, 아니면 켜기


      const item = {
        kind: kind,
        deviceId: firstCarrier.id,
        controllItems: ["01"],
        controllValues: values
      
      };
  

       axios.post("/api/device/controll", item)
            .then((response) => {
             console.log("캐리어 제어 명령 전송 성공", response);
            })
            .catch((error) => {
             console.error("캐리어 제어 명령 전송 실패", error);
          
            });
        
        // if (result && result.resultMsg === 'success') {
          Message({
            iconClass: "success",
            type: "success",
            message: t('key612'), // 성공적으로 수행되었습니다.
          })
        // } else {
        //   Message({
        //     iconClass: "cancel",
        //     type: "warning",
        //     message: "전체 전원 관리에 실패했습니다.",
        //   });
        // }
        const updatedCarrierData = carrierData.map((carrier) => {
        
          return {
            ...carrier,
            // ucOpMode: this.state.allPowerSwitchStatus ? POWER_STATE.off : POWER_STATE.on,
            powerState: this.state.allPowerSwitchStatus ? 0 : 1,
          };
        
        });
    
        this.setState({
          allPowerSwitchStatus: !this.state.allPowerSwitchStatus,
          carrierData: updatedCarrierData,
        });
      }).catch(() => {
        // cancel
        Message({
          iconClass: "cancel",
          type: "info",
          message: t('key613'), // 작업이 취소되었습니다.
        })
      })
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: t('key616'), // 전체 전원 관리에 실패했습니다.
      });
    }
  }
  //-----------------S: handler function -----------------//
  handleShowDetailInfo(matchedBoilerStorageTankData) { // 기기 상세정보 토글
    const {
      boiler: { device: boilerDevice },
      storageTank: { device: storageTankDevice },
    } = matchedBoilerStorageTankData;

    this.setState((prev) => {
      const isSame = prev.openDeviceId.boiler === boilerDevice.id 
                     || prev.openDeviceId.storageTank === storageTankDevice.id;

      const openDeviceId = {
        boiler: isSame ? null : boilerDevice.id,
        // storageTank: isSame ? null : storageTankDevice.id,
        storageTank: null
      }
      return {
        openDeviceId,
      };
    });
  }

  handleTargetTemp(event, { data, min, max, kind, controlKind, tempKey }) { // 목표 온도 변경
    event.preventDefault();
    event.stopPropagation();
    const { t } = this.props;
    const { name } = event.target;
    const { device, carrier } = data;
    try {
      // data가 없을 경우 에러 메세지 출력
      if (!carrier || !carrier[tempKey]) throw new Error(t('key617')); // 해당기기의 온도 데이터가 없습니다.
      if (carrier[tempKey] <= min && name === "down") throw new Error(`${t('key619')} ${t('key620')} ${min}${t('key622')}`); // 해당기기 목표 온도는 최소 °C 입니다.
      if (carrier[tempKey] >= max && name === "up") throw new Error(`${t('key619')} ${t('key621')} ${max}${t('key622')}`); // 해당기기 목표 온도는 최대 °C 입니다.
      if (device?.tempContr !== 1) throw new Error(t('key618')); // 해당기기는 온도조절이 불가능합니다.

      const step = name === "up" ? 1 : name === "down" ? -1 : 0;
      const targetTemp = (Number(carrier[tempKey]) + step).toFixed(1);

      //TODO: api 호출
      this.updateTempSet(carrier._id, targetTemp, tempKey);

      if (kind) {
        this.fetchContrCarrierTemp(carrier, kind, controlKind, targetTemp);
      }
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: error.message || t('key607'), // 보일러 목표 온도 설정에 실패했습니다.
      });
      // console.error("보일러 목표 온도 설정 Error", error);
    }
  }

  handleSlideTemp = ({data, min, max, tempKey}) => (event, value) => { // 슬라이드로 목표 온도 변경
    event.preventDefault();
    event.stopPropagation();
    const { t } = this.props;
    const { device } = data;
    try {
      if (device?.tempContr !== 1) throw new Error(t('key618')); // 해당기기는 온도조절이 불가능합니다.
      
      this.updateTempSet(data?.carrier?._id, value.toFixed(1), tempKey);
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: error.message || t('key607'), // 보일러 목표 온도 설정에 실패했습니다.
      });
    }
  }
  
  handleSlideTempFetchApi = ({data, min, max, kind, controlKind, tempKey}) => (event) => {
    // event.preventDefault();
    event.stopPropagation();
    const { t } = this.props;
    const { device, carrier } = data;
    try {
      if (!carrier || !carrier[tempKey]) throw new Error(t('key617')); // 해당기기의 온도 데이터가 없습니다.
      if (device?.tempContr !== 1) throw new Error(t('key618')); // 해당기기는 온도조절이 불가능합니다.

      if (kind) {
        this.fetchContrCarrierTemp(carrier, kind, controlKind, carrier[tempKey]);
      }
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: error.message || t('key607'), // 보일러 목표 온도 설정에 실패했습니다.
      });
    }
  }

  handleGaugeTempSet = ({ data, tempKey, value }) => {
    const { carrier } = data;
    if (!carrier) return;
    const newValue = parseFloat(value).toFixed(1);
    this.updateTempSet(carrier._id, newValue, tempKey);
  }

  handleAllDeviceStatus() { // 전체 기기 상태 변경
    const { allDeviceStatus } = this.state;
    const { t } = this.props;

    if (allDeviceStatus === 4) {
      MessageBox.confirm(t('key623'), "Confirm", { // 전체 기기 점검중을 해제하시겠습니까?
        confirmButtonText: t('key610'), // 예
        cancelButtonText: t('key611'), // 아니오
        type: "info",
      }).then(() => {
        // TODO: 전체 기기 상태 변경 API 연동 필요
        // TODO: 기존 점검중 제외 원래 상태값
        Message({
          iconClass: "success",
          type: "success",
          message: t('key612'), // 성공적으로 수행되었습니다.
        })
        this.setState({
          allDeviceStatus: 1,
        });
      }).catch(() => {
        Message({
          iconClass: "cancel",
          type: "info",
          message: t('key613'), // 작업이 취소되었습니다.
        })
      })
    } else {
      MessageBox.confirm(t('key624'), "Confirm", {
        confirmButtonText: t('key610'), // 예
        cancelButtonText: t('key611'), // 아니오
        type: "info",
      }).then(() => {
        // TODO: 전체 기기 상태 변경 API 연동 필요
        Message({
          iconClass: "success",
          type: "success",
          message: t('key612'), // 성공적으로 수행되었습니다.
        })
        this.setState({
          allDeviceStatus: 4,
        });
      }).catch(() => {
        Message({
          iconClass: "cancel",
          type: "info",
          message: t('key613'), // 작업이 취소되었습니다.
        })
      })
    }
  }
  //-----------------E: handler function -----------------//

  //-----------------S: helper function -----------------//
  calcAllTotalConsPower (dataList) { // 누적 소비 전력
    return dataList.reduce((acc, cur) => {
      return acc + cur.totalConsPower;
    }, 0);
  }

  calcAllPower1hAver(dataList) { // 1시간 평균 전력
    const allSumData = dataList.reduce((acc, cur) => {
      return acc + Number(cur.consPower1hAver);
    }, 0);
    return allSumData / dataList.length;
  }
  isErrorDevice(matchedBoilerStorageTankData) {
    const { boiler, storageTank, children } = matchedBoilerStorageTankData;
    console.log("matchedBoilerStorageTankData: ", matchedBoilerStorageTankData);
    let isError = false;

    // if (children && children.length > 0) {
    //   // 하위 보일러가 있는 경우
    //   children.forEach((child) => {
    //     if (!child.carrier) {
    //       isError = true; // 하위 보일러 패킷 데이터 없을 경우
    //     }
    //   });
    // }

    if (!boiler?.carrier) isError = true; // 패킷 데이터 없을 경우
    // if (boiler?.carrier && boiler.carrier.powerState === 0) isError = true; // 보일러 전원 꺼짐

    return isError;
  }

  isTempContr(device) {
    // 온도 조절 가능 여부
    
    if (device?.tempContr === 1) {
      return true;
    } else {
      return false;
    }
  }

  mappingDeviceCarrier(deviceList, carrierData) { // device정보와 carrier정보 매핑
    const deviceCarrierMappingData = [];
    deviceList.forEach((device) => {
      const findCarrier = carrierData.find((carrier) => {
        // // siteNo, deviceNo, rtuId가 모두 일치하는 데이터 찾기
        // const isSameDeviceNo = carrier.deviceNo == device.deviceNo;
        // const isSameSiteNo = carrier.siteNo == device.siteNo;
        // const isSameRtuId = (Number(carrier.rtuId) % 10) == device.rtuNo;
        // console.log("isSameDeviceNo: ", isSameDeviceNo, "isSameSiteNo: ", isSameSiteNo, "isSameRtuId: ", isSameRtuId);
        const deviceKey = MakeKey.carrier({ siteNo: device.siteNo, rtuNo: device.rtuNo, deviceNo: device.deviceNo });
        
        return deviceKey === carrier._id;
      });
      deviceCarrierMappingData.push({
        device,
        carrier: findCarrier
      });
    });
    return deviceCarrierMappingData;
  }

  matchBoilderAndStorageTank(deviceCarrierMappingData) { // 보일러와 축열조 매칭
    const boilerList = deviceCarrierMappingData.filter((data) => data.device.typeId === 1); // 보일러 리스트 typeId: 1 
    const storageTankList = deviceCarrierMappingData.filter((data) => data.device.typeId === 4); // 축열조 리스트 typeId: 4
    const matchedList = [];
    //보일러 기준 연결된 축열조를 찾아서 맵핑
    boilerList.forEach((boiler) => {
      const parentId = boiler.device.parentId;
      // 보일러에서 parentId가 없으면 축열조와 연결되지 않은 보일러이므로 매칭하지 않음
      if (!parentId) return;
      // 축열조와 연결된 대표 보일러
      const findStorageTank = storageTankList.find((storage) => storage.device.id === parentId);
      if (findStorageTank) {
        matchedList.push({
          boiler,
          storageTank: findStorageTank
        });
        return;
      }
    });
    // 하위 보일러 추가
    boilerList.forEach(boiler => {
      const parentId = boiler.device.parentId;
      if (!parentId) return;
  
      const parentMatched = matchedList.find(m => m.boiler.device.id === parentId);
      if (parentMatched) {
        if (!parentMatched?.children) {
          parentMatched.children = [];
        }
        parentMatched.children.push(boiler);
      }
    });

    return matchedList;
  }
  //-----------------E: helper function -----------------//
  render() {
    const {
      project: { projectName, projectAddr },
      openDeviceId,
      cumulativePower,
      power1hAver,
      consPowerTodayMap,
      allPowerSwitchStatus,
      matchedBoilerStorageTank,
      allDeviceStatus,
      deviceList,
      noMatchedBoiler,
      carrierSerialNos
    } = this.state;
    const { t, i18n } = this.props;
    const deviceTypeId = this.props.location.state?.device?.typeId || null;
    // 상단 "금일 소비전력"은 각 DetailCarrierCard가 조회한 boiler별 값의 합으로 노출
    const allConsPowerToday = Object.values(consPowerTodayMap).reduce((acc, cur) => acc + (cur || 0), 0);
    return (
      <>
        <PageTitle title={t("key47")} location={t('key238')} />
        {
          deviceTypeId === 6 ? (
            <iframe 
              title="external-monitoring"
              src={this.props.location.state.device?.externalUrl}
              width="100%"
              height={"1000px"}
              style={{ border: "none", marginBottom: "30px", width: "1176px", margin: "0 auto", display: "block" }}
            />
          ) : (
            <InfoArea>
              <InfoHead>
                {/* <h1>{device.name}</h1> */}
                <h1>{projectName}</h1>
              </InfoHead>
              <InfoContent>
                <dl>
                  <dt>{t('key239')}</dt>
                  <dd>{projectAddr}</dd>
                </dl>
              </InfoContent>
              <InfoList>
                <h2>{t('key240')}</h2>
                <ListWrapper columns={DetailCarrierInfoGrid(i18n)} gap={"24px"}>
                  <InfoListBox>
                    <p>{t('key241')}</p>
                    <ul>
                      <li>
                        <CountUp
                          start={0}
                          end={cumulativePower}
                          decimals={0}
                          duration={0.5}
                          separator=","
                        />
                      </li>
                      <li>kWh</li>
                    </ul>
                  </InfoListBox>
                  <InfoListBox>
                    <p>{t('key242')}</p>
                    <ul>
                      <li>
                        <CountUp
                          start={0}
                          end={allConsPowerToday}
                          decimals={2}
                          duration={1}
                          separator=","
                        />
                      </li>
                      <li>kWh</li>
                    </ul>
                  </InfoListBox>
                  <InfoListBox>
                    <p>{t('key243')}</p>
                    <ul className="control-box">
                      <li>{t('key244')}</li>
                      <li>
                        <AllDeviceStatusButton 
                          deviceStatus={allDeviceStatus} 
                          onClick={() => this.handleAllDeviceStatus()} // 전체 기기 상태 변경 API 연동 필요
                          t={t}
                        />
                      </li>
                    </ul>
                  </InfoListBox>
                  <InfoListBox>
                    <p>+DR</p>
                    <ul className="control-box">
                      <li> </li>
                      <li>
                        <StatusButton type={isDrActive(deviceList) ? "error" : "on"}>
                          {isDrActive(deviceList) ? t('key251') : t('key250')}
                        </StatusButton>
                      </li>
                    </ul>
                  </InfoListBox>
                </ListWrapper>
              </InfoList>
              <ControlArea>
                <ControlTitle>
                  <h3>{t('key252')}</h3>
                  {/* 전체 전원 관리 버튼 주석처리
                  <div className="full-power">
                    <p>{t('key253')}</p>
                    <ToggleSwitch
                      isChecked={allPowerSwitchStatus}
                      name="power"
                      htmlFor="switchAll"
                      onClick={() => this.handleAllPowerSwitch()}
                    />
                  </div>
                  */}
                </ControlTitle>
                {
                  matchedBoilerStorageTank?.map((data, idx) => {
                    const {
                      boiler: {
                        device: boilerDevice,
                        carrier: boilerCarrier,
                      },
                      children,
                      storageTank: {
                        device: storageTankDevice,
                        carrier: storageTankCarrier,
                      },
                    } = data;
                    const isActiveDevice = openDeviceId.boiler === boilerDevice.id || openDeviceId.storageTank === storageTankDevice.id || children?.some((child) => openDeviceId.boiler === child.device.id);
                    return (
                      <DetailCarrierCard
                        key={boilerDevice.id}
                        isActiveDevice={isActiveDevice}
                        handleShowDetailInfo={() => this.handleShowDetailInfo(data)}
                        isTempContr={this.isTempContr}
                        handleTargetTemp={this.handleTargetTemp}
                        handleSlideTemp={this.handleSlideTemp}
                        handleSlideTempFetchApi={this.handleSlideTempFetchApi}
                        handleGaugeTempSet={this.handleGaugeTempSet}
                        handlePowerSwitch={this.handlePowerSwitch}
                        setTargetRef={this.setTargetRef}
                        openDeviceId={openDeviceId}
                        data={data}
                        onConsPowerTodayUpdate={this.handleConsPowerTodayUpdate}
                        t={t}
                        i18n={i18n}
                      />
                    )
                  })
                }
                {
                  noMatchedBoiler.length > 0 &&
                  noMatchedBoiler.map((data) => {
                    const { device: boilerDevice, carrier: boilerCarrier } = data;
                    const isActiveDevice = openDeviceId.boiler === boilerDevice.id;
                    return (
                      <DetailCarrierCard
                        key={boilerDevice.id}
                        isActiveDevice={isActiveDevice}
                        handleShowDetailInfo={() => this.handleShowDetailInfo({ boiler: { device: boilerDevice, carrier: boilerCarrier }, storageTank: { device: {}}})}
                        isTempContr={this.isTempContr}
                        handleTargetTemp={this.handleTargetTemp}
                        handleSlideTemp={this.handleSlideTemp}
                        handleSlideTempFetchApi={this.handleSlideTempFetchApi}
                        handleGaugeTempSet={this.handleGaugeTempSet}
                        handlePowerSwitch={this.handlePowerSwitch}
                        setTargetRef={this.setTargetRef}
                        openDeviceId={openDeviceId}
                        data={{ boiler: { device: boilerDevice, carrier: boilerCarrier }, storageTank: { device: {}}}}
                        onConsPowerTodayUpdate={this.handleConsPowerTodayUpdate}
                        t={t}
                        i18n={i18n}
                      />
                    )
                  })
                }
              </ControlArea>
              {
                this.state.meterSerialNos.length > 0 && (
                  <DetailMeterSection 
                    meterSerialNos={this.state.meterSerialNos}
                    meterData={this.state.meterData}
                    t={t}
                  />
                )
              }
              <PowerGraph
                carrierSerialNos={carrierSerialNos || []}
              />
            </InfoArea>
          )
        }
      </>
    );
  }
}

class AllDeviceStatusButton extends Component {
  render() {
    const { deviceStatus, onClick, t } = this.props;
    return (
      <DeviceStatusButton deviceStatus={deviceStatus} onClick={onClick}>
        {deviceStatus === 1
          ? t('key245')
          : deviceStatus === 2
          ? t('key246')
          : deviceStatus === 3
          ? t('key247')
          : deviceStatus === 4
          ? t('key248')
          : t('key248')}
      </DeviceStatusButton>
    );
  }
}

const DeviceStatusButton = styled.button`
  font-size: 14px;
  font-weight: bold;
  padding: 4px 20px;
  width: 100%;
  color: #fff;
  border-radius: 28px;
  ${({ deviceStatus }) => {
    if (deviceStatus === 1) { // 정상
      return `
        background-color: #34e466;
        border: solid 1px #63ee4c;
        box-shadow: 0 0 6px 0 rgba(69, 255, 65, 0.76);
      `;
    } else if (deviceStatus === 2) { // 고장
      return `
        background-color: #FF4242;
        border: solid 1px #FF6363;
        box-shadow: 0 0 6px 0 rgba(255, 66, 66, 0.76);
      `;
    } else if (deviceStatus === 3) { // 통신 오류
      return `
        background-color: #FFCA42;
        border: solid 1px #FFCD4E;
        box-shadow: 0 0 6px 0 rgba(252, 185, 15, 0.76);
      `;
    } else if (deviceStatus === 4) { // 점검 중
      return `
        background-color: #7E7E7E;
        border: solid 1px #9B9B9B;
        box-shadow: 0 0 6px 0 rgba(126, 126, 126, 0.76);
      `;
    } else {
      return `
        background-color: #7E7E7E;
        border: solid 1px #9B9B9B;
        box-shadow: 0 0 6px 0 rgba(126, 126, 126, 0.76);
      `;
    }
  }}
`;
const ControlArea = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: solid 1px #000;
`;
const ControlTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  align-items: center;
  padding: 30px 0 15px;
  .full-power {
    text-align: right;
    p {
      display: inline-block;
      vertical-align: middle;
      padding: 0 12px 0 0;
    }
  }
`;
export default withTranslation()(withRouter(PowerCarrierDetail));

function isDrActive(deviceList) {
  let isDrActive = false;
  deviceList.forEach((device) => {
    if (device.drYn === 1) {
      isDrActive = true;
    }
  });
  return isDrActive;
}